/**
 * Tiny event bus for cache-invalidation signals.
 *
 * The SSE hook calls `emitCacheEvent(event)` whenever the backend pushes a
 * `cache_invalidated` event. Pages subscribe via `subscribeCacheRefresh(fn)`
 * to silently re-fetch their data.
 *
 * Debounce: if multiple events arrive within a short window (e.g. Odoo bulk
 * edit causing several signature bumps), we collapse them into a single
 * refresh call to avoid hammering the API.
 */

const listeners = new Set();
let pending = null;
let debounceTimer = null;
const DEBOUNCE_MS = 1500;

export function emitCacheEvent(event) {
  pending = event;
  if (debounceTimer) clearTimeout(debounceTimer);
  debounceTimer = setTimeout(() => {
    const ev = pending;
    pending = null;
    debounceTimer = null;
    listeners.forEach((fn) => {
      try { fn(ev); } catch { /* swallow listener errors */ }
    });
  }, DEBOUNCE_MS);
}

export function subscribeCacheRefresh(fn) {
  listeners.add(fn);
  return () => { listeners.delete(fn); };
}
